/**
 * The twelve-star circle of the European emblem, drawn rather than shipped as an
 * image: it sits at three sizes between phone and desktop, and a raster would
 * either soften at the largest or cost a 2x asset for the smallest.
 *
 * Emblem geometry, so the ring reads as the real thing: twelve stars with their
 * centres on one circle, one star upright at twelve o'clock and the rest every
 * 30 degrees. The emblem's own spec makes each star's circumscribed circle a
 * third of the ring radius; the mockup draws them at 0.28, measured off its
 * 45px stars on an 85px ring, which is what keeps daylight between the points.
 */
const RING_RADIUS = 100;
const STAR_RADIUS = RING_RADIUS * 0.28;

const starPoints = () => {
  // A five-pointed star: ten alternating points, outer then inner, starting at
  // the tip. The inner radius of a pentagram is its outer radius / golden ratio².
  const inner = STAR_RADIUS / 2.618;
  return Array.from({ length: 10 }, (_, i) => {
    const r = i % 2 === 0 ? STAR_RADIUS : inner;
    const angle = (Math.PI / 5) * i - Math.PI / 2;
    return `${(r * Math.cos(angle)).toFixed(2)},${(r * Math.sin(angle)).toFixed(2)}`;
  }).join(" ");
};

const points = starPoints();

export const EuStarRing = ({ className }: { className?: string }) => (
  <svg
    viewBox="-129 -129 258 258"
    className={className}
    fill="#fff"
    aria-hidden="true"
    focusable="false"
  >
    {Array.from({ length: 12 }, (_, i) => {
      const angle = (Math.PI / 6) * i - Math.PI / 2;
      const x = RING_RADIUS * Math.cos(angle);
      const y = RING_RADIUS * Math.sin(angle);
      return (
        <polygon
          key={`eu-star-${i}`}
          points={points}
          transform={`translate(${x.toFixed(2)} ${y.toFixed(2)})`}
        />
      );
    })}
  </svg>
);
